import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default function SetPlayerMembershipRevokeDialog({
  openState,
  userContext,
  onClose,
  onRevokeMembership,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (openState) {
      setSubmitting(false);
      setError("");
    }
  }, [openState, userContext?.userId]);

  if (!("row" in userContext)) {
    return <></>;
  }

  const membership = userContext.row?.membership || {};
  const tier = membership.tier || "unknown";
  const nickname = userContext.row?.nickname || userContext.row?.name || "this user";

  const handleConfirm = async () => {
    setSubmitting(true);
    setError("");

    const result = await onRevokeMembership({ userId: userContext.row.userId });

    if (result?.ok) {
      setSubmitting(false);
      onClose();
      return;
    }

    setError(result?.error || "Failed to revoke membership");
    setSubmitting(false);
  };

  return (
    <Dialog
      open={openState}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="revoke-membership-dialog-title"
    >
      <DialogTitle id="revoke-membership-dialog-title">
        Revoke free grant for {nickname}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will immediately remove the admin-granted complimentary{" "}
          <strong>{tier.charAt(0).toUpperCase() + tier.slice(1)}</strong> membership and return the
          user to the Free tier.
        </DialogContentText>

        <Typography variant="body2" style={{ marginBottom: 12 }}>
          <strong>User ID:</strong> {userContext.row.userId}
        </Typography>

        <Typography variant="body2" color="textSecondary">
          This action cannot be undone. A new grant will be required to restore membership.
        </Typography>

        {error && (
          <Typography variant="body2" style={{ marginTop: 12, color: "#d32f2f" }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default" disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="secondary"
          disabled={submitting}
          style={{ color: "#d32f2f" }}
        >
          {submitting ? "Revoking..." : "Revoke Grant"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
